import { mockProjects } from '@/data/projectsData';
import type { ProjectDetails } from '@/types/project';
import type { ProjectStatsResponse } from '@/services/projectsApi';

export const DEFAULT_PROJECT_STATS: ProjectStatsResponse = {
  totalProjects: 0,
  activeProjects: 0,
  atRiskCount: 0,
  highPriorityCount: 0,
  totalTeamMembers: 0,
};

/** Client-side filtering and sorting of the mock project list (demo mode). */
export const filterAndSortMockProjects = (
  searchQuery: string,
  statusFilter: string,
  priorityFilter: string,
  sortBy: string
): ProjectDetails[] => {
  const filtered = mockProjects.filter(project => {
    const matchesSearch = searchQuery === '' || 
      project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      project.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
      project.clientName.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || project.status === statusFilter;
    const matchesPriority = priorityFilter === 'all' || project.priority === priorityFilter;
    return matchesSearch && matchesStatus && matchesPriority;
  });
  filtered.sort((a, b) => {
    switch (sortBy) {
      case 'name': return a.name.localeCompare(b.name);
      case 'code': return a.code.localeCompare(b.code);
      case 'client': return a.clientName.localeCompare(b.clientName);
      case 'startDate': return a.timeline.startDate.getTime() - b.timeline.startDate.getTime();
      case 'endDate': return a.timeline.endDate.getTime() - b.timeline.endDate.getTime();
      default: return 0;
    }
  });
  return filtered;
};

/** Stats derived from the mock project list (demo mode). */
export const computeDemoStats = (): ProjectStatsResponse => ({
  totalProjects: mockProjects.length,
  activeProjects: mockProjects.filter(p => p.status === 'active').length,
  atRiskCount: mockProjects.filter(p => p.status === 'at-risk').length,
  highPriorityCount: mockProjects.filter(p => p.priority === 'high').length,
  totalTeamMembers: mockProjects.reduce((sum, p) => sum + p.teamSize, 0),
});
